import PropTypes from 'prop-types';

import styles from './FeatureBox.module.scss';

const FeatureBox = ({ title, content, renderImage }) => {
  return (
    <div className={styles['feature-box']}>
      <div>{renderImage()}</div>
      <div>
        <h3 className={styles['feature-box__title']}>{title}</h3>
        <p className={styles['feature-box__content']}>{content}</p>
      </div>
    </div>
  );
};

FeatureBox.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  renderImage: PropTypes.func.isRequired
};

export default FeatureBox;
